<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>收益率曲线管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="名称">
				<el-select v-model="formInline.yieldCurveName" placeholder="选择代码" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in allNames"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<!-- <el-button size="small" type="primary" icon="el-icon-search" @click="search">导出</el-button> -->
				<!-- <el-button size="small" type="danger" icon="el-icon-search" @click="add">新增</el-button> -->
			</el-form-item>
			<el-form-item>
				<el-upload
				:action=url
				accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
				:on-preview="handlePreview"
				:on-remove="handleRemove"
				:on-success="handleSuccess"
				multiple
				:limit="limitUpload"
				:on-exceed="handleExceed"
				:with-credentials="true"
				:headers="headers"
				:file-list="fileList">
				<el-button  type="danger" @click="handlePreview" v-if="jurisdiction.includes(424)">导入</el-button>
				</el-upload>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row  border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="yieldCurveName" label="名称"  align="center"></el-table-column>
			<el-table-column prop="dateTime" label="日期"  align="center"></el-table-column>
            <el-table-column prop="yieldCurveValue" label="值"  align="center"></el-table-column>
		</el-table>
		
		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>


	</div>
</template>

<script>
	import {
		getBondYieldCurveNameAll,
		// getBondYieldCurveAll,
		getBondYieldCurveList
	} from '../../api/basisMG.js'

	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			
			//数据  
			return {
				jurisdiction:JSON.parse(sessionStorage.getItem('jurisdiction')),
				allNames:[],
				quoteTypes:[],
				action:localStorage.getItem("baseUrl"),
				url:localStorage.getItem("baseUrl")+"/manager/bonddb/importBondYieldCurve",
				dialogVisible: false,
				rules:{
                    bondCode :[{required: true, message: '请输入', trigger: 'blur'}],
                    sex :[{required: true, message: '请输入', trigger: 'blur'}]
                },
				editForm: {
					bondCode:""
				},

				
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],
				listData: [],
				dialogImageUrl: '',

				uids: '',
				tagIds: '',
				vipName: '',
				agentName: '',
				vipLevel: '',
				agentLevel: '',
				// 所属分类
				tableData: [],
				value: [],
				selectEditForm: {},
				usernames: ''
			}
		},


		watch: {},

		methods: {
			// 获得表格数据
			getdata() {
				let param = this.formInline
				getBondYieldCurveList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})
			},

			getAllCodeTypes() {
				getBondYieldCurveNameAll().then(res => {
					if (res.code == '200') {
						this.allNames = res.data
					}
				})
			},
		},


		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path),
			this.getAllCodeTypes(),
			this.getdata()

		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>